import React from "react";

const MarkerInfoBox = ({ categories, handleToggleFilter, pin, setActiveDetail, setDetailsPanelActive }) => {
  const currentCategory = categories.filter((category: any) => {
    if (!pin.category) return false
    return category.id === pin.category.id
  }).pop()

  return (
    <div className="sopa--infobox">
      {currentCategory &&
        <span dangerouslySetInnerHTML={{ __html: `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 5C0 7.75744 2.24211 10 5.00101 10C7.75789 10 10 7.75744 10 5C10 2.24256 7.75789 1.35181e-06 5.00101 1.35181e-06C2.24211 -0.00200991 0 2.24055 0 5ZM1.61271 5C1.61271 3.13154 3.13091 1.61102 5.00101 1.61102C6.87111 1.61102 8.39131 3.13154 8.39131 5C8.39131 6.87048 6.87111 8.39099 5.00101 8.39099C3.13091 8.38898 1.61271 6.86846 1.61271 5Z" fill="#214A66"/></svg><span class="sopa--infobox_category">${currentCategory.name}</span>` }} />
      }
      {pin.title && <div><strong>{pin.title}</strong></div>}
      {pin.description && <div dangerouslySetInnerHTML={{ __html: `${pin.description}` }}></div>}
      <div className="sopa--infobox_actions">
        <button onClick={(evt) => { handleToggleFilter(evt); setDetailsPanelActive(true); setActiveDetail(pin.id); }} data-toggle="filter" className="nsw-button nsw-button--dark">View Details</button>
        {pin.optionalButton !== null && pin.optionalButton.url && <a href={pin.optionalButton.url} target="_blank" className="nsw-button nsw-button--dark-outline desktop-only">{pin.optionalButton.title}</a>}
      </div>
    </div>
  )
}

export default MarkerInfoBox
